/**
 *
 * ClassRestrictionMixin.mixin
 *
 */

import { mapState, mapActions } from 'vuex';
//import _ from 'lodash';

export const ClassChineseFrmMixin = {
  name: 'ClassChineseFrmMixin',

  data: () => {
    return {
      isShowFileDownLoadTip: true,
    };
  },

  computed: {
    ...mapState('Mixins/ClassChineseFrm', {
      ms_classChineseFrm: 'classChineseFrm',
    }),

    //
    CourseId() {
      return -1;
    },

    c_courseId() {
      return Number(this.CourseId);
    },

    //
    BookId() {
      return -1;
    },

    c_bookId() {
      return Number(this.BookId);
    },

    c_isHideFileDownLoadTip() {
      return !(this.isShowFileDownLoadTip && this.ms_classChineseFrm.isFrmChinese && !this.ms_classChineseFrm.webRead);
    },
  },

  methods: {
    ...mapActions('Mixins/ClassChineseFrm', {
      ma_getClassChineseFrm: 'getClassChineseFrm',
      ma_postClassChineseFrmConfirm: 'postClassChineseFrmConfirm',
    }),

    async getClassChineseFrm() {
      await this.ma_getClassChineseFrm({
        courseId: this.c_courseId,
        bookId: this.c_bookId,
      });
    },

    async closeClassChineseFrmDownLoadTip() {
      this.isShowFileDownLoadTip = false;
      await this.ma_postClassChineseFrmConfirm({
        courseId: this.c_courseId,
        bookId: this.c_bookId,
      });
    },

    ClassChineseFrmMixinCreated() {
      this.getClassChineseFrm();
    },
  },

  created() {
    this.ClassChineseFrmMixinCreated();
  },
};

export default ClassChineseFrmMixin;
